<template>
	<div v-if="playbook" class="c-view">
		<InternalHeader>
			<div slot="title" class="c-internal-header__title">
				<a @click="$router.push('/playbooks')">
					<Icon :custom="'icon icon-arrow-left-1'"></Icon>
					Playbooks
				</a>
				/
				<a
					@click="
						$router.push(
							'/playbooks/' + playbook.id + '/summary-instances'
						)
					"
				>
					{{ playbook.name }}
				</a>
				/ Summary
			</div>
		</InternalHeader>
		<Row class="mt-5" :gutter="16">
			<Col span="6">
				<playbook-subnav :playbook-id="playbookId"></playbook-subnav>
			</Col>
			<Col span="18">
				<playbook-status
					:value="playbook.status_id"
					@update="mixinPlaybook_savePlaybook"
				></playbook-status>
				<h3 class="mt-5">
					<a
						@click="
							$router.push(
								'/playbooks/' +
									playbookId +
									'/summary-instances'
							)
						"
					>
						<Icon :custom="'icon icon-arrow-left-1'"></Icon>
					</a>
					{{ statusLabel }} / {{ dateRangeLabel }}
				</h3>
				<Row :gutter="16" class="mt-5">
					<Col span="24">
						<Card
							dis-hover
							class="custom-ivu-card-chart c-pinnable c-pinnable__widget"
						>
							<add-widget
								class="c-widget-add__padded"
								:definition="chartDefinition"
								:dashboard-type-ids="[1]"
							>
								<Button
									slot="trigger"
									size="small"
									custom-icon="icon icon-pin"
								></Button>
							</add-widget>
							<div class="custom-ivu-card-chart-heading"></div>
							<div style="height: 120px;">
								<playbooks-status-history
									:definition="chartDefinition"
									format="full"
								></playbooks-status-history>
							</div> </Card
					></Col>
				</Row>
				<Row :gutter="16" class="mt-5" style="min-height: 92px;">
					<Col span="24">
						<playbooks-filters
							v-bind:user-id.sync="assignedToId"
							:users-enabled="true"
							:playbooks-enabled="false"
						></playbooks-filters>
					</Col>
				</Row>
				<Row :gutter="16" class="mt-5">
					<Col>
						<p>
							<add-widget
								class="c-widget-add__padded float-right"
								:definition="definition"
								:dashboard-type-ids="[1]"
							>
								<Button
									slot="trigger"
									size="small"
									custom-icon="icon icon-pin"
								>
								</Button> </add-widget
							>Playbooks {{ label }}
						</p>
						<playbook-instances
							class="mt-5"
							:definition="definition"
						></playbook-instances>
					</Col>
				</Row>
			</Col>
		</Row>
	</div>
</template>

<script>
import DateRange from "@/js/lookups/date-range";
import Playbook from "@/js/mixins/playbook.js";
export default {
	props: {
		status: String,
		dateStart: String,
		dateEnd: String,
		dateRangeTypeId: String,
		playbookId: Number,
		statusIds: Array,
	},
	mixins: [Playbook],
	data() {
		return {
			dateRange: new DateRange(parseInt(this.dateRangeTypeId)),
			assignedToId: null,
		};
	},
	components: {
		AddWidget: function() {
			return import("@/js/components/partials/add-widget");
		},
		PlaybookInstances: function() {
			return import(
				"@/js/components/partials/widgets/playbook-instances"
			);
		},
		InternalHeader: function() {
			return import("@/js/components/partials/header");
		},
		PlaybooksFilters: function() {
			return import("@/js/components/partials/playbooks-filters");
		},
		PlaybooksStatusHistory: function() {
			return import(
				"@/js/components/partials/widgets/playbooks-status-history"
			);
		},
		PlaybookStatus: function() {
			return import("@/js/components/partials/playbook-status");
		},
		PlaybookSubnav: function() {
			return import("@/js/components/partials/playbook-subnav");
		},
	},
	created() {
		this.init();
	},
	watch: {
		dateRange: {
			handler: function() {
				this.definition.dateRange = this.dateRangeDefinition;
			},
			deep: true,
		},
		assignedToId(newVal) {
			if (newVal) {
				this.definition.userId = newVal;
			} else {
				this.definition.userId = null;
			}
		},
		playbook: {
			handler() {
				if (this.playbook) {
					this.$root.$emit("page-title:update", this.playbook.name);
				}
			},
			deep: true,
		},
	},
	computed: {
		dateRangeLabel() {
			if (this.status != "Open" && this.status != "Overdue") {
				return this.dateRange.dateRangeLabel();
			} else return "";
		},
		label() {
			return this.dateRange.label();
		},
		dateRangeDefinition() {
			return this.dateRange.definition();
		},
		playbookName() {
			return this.playbook ? this.playbook.name : "";
		},
		statusLabel() {
			if (this.status) {
				return (
					this.status.charAt(0).toUpperCase() + this.status.slice(1)
				);
			} else {
				return "";
			}
		},
		definition() {
			let definition = {
				label: null,
				type: "PlaybookInstances",
				statusIds: [],
				userId: null,
				outcomeId: null,
				playbookId: this.playbookId,
				dateRange: null,
				dateFilterField: null,
			};

			switch (this.status) {
				case "open":
					definition.label = "Playbooks Open";
					definition.statusIds = [1, 4];
					definition.columns = ["triggered", "status", "entity"];
					break;
				case "overdue":
					definition.label = "Playbooks Overdue";
					definition.statusIds = [1, 4, 100];
					definition.columns = ["triggered", "status", "entity"];
					break;
				case "paused":
					definition.label = "Playbooks Paused";
					definition.statusIds = [4];
					definition.columns = ["triggered", "status", "entity"];
					break;
				default:
					break;
			}

			definition.label = definition.label + " " + this.dateRange.label();
			definition.dateRange = this.dateRange.definition();

			if (this.assignedToId) {
				definition.userId = this.assignedToId;
			}
			return definition;
		},
		chartDefinition() {
			let definition = {
				label: null,
				type: "PlaybooksStatusHistory",
				statusId: null,
				playbookId: this.playbookId,
				userId: null,
			};

			switch (this.status) {
				case "open":
					definition.label = "Playbooks Open";
					definition.statusId = 1;
					break;
				case "overdue":
					definition.label = "Playbooks Overdue";
					definition.statusId = 100;
					break;
				case "paused":
					definition.label = "Playbooks Paused";
					definition.statusId = 4;
					break;
				default:
					break;
			}

			definition.label = definition.label + " " + this.dateRange.label();
			definition.dateRange = this.dateRange.definition();

			if (this.assignedToId) {
				definition.userId = this.assignedToId;
			}
			return definition;
		},
	},
	methods: {
		init() {
			this.setDateRanges();
		},
		setDateRanges() {
			if (this.status != "Open" && this.status != "Overdue") {
				if (
					this.dateStart &&
					this.dateEnd &&
					this.dateRangeTypeId == 5
				) {
					this.dateRange.dates.start = this.dateStart;
					this.dateRange.dates.end = this.dateEnd;
				}
			}
		},
	},
};
</script>
